<script setup lang="ts">
import { useMainPageSeo } from '@/composables/useMainPageSeo'
import { useScrollToBlock } from '@/composables/useScrollToBlock'

import HomePhotoBlock from '@/components/HomePhotoBlock/HomePhotoBlock.vue'

import { CitiesBlock } from '@features/cities'
import { NewsPreview } from '@features/news'
import { DailyStatistics } from '@features/statistics'

useScrollToBlock()
const { title, seo } = await useMainPageSeo()

useHead({
  title,
  ...seo,
})
</script>

<template>
  <div class="home-page">
    <Head>
      <Meta name="yandex-verification" content="d07b19776e5595f8" />
    </Head>

    <cities-block />

    <div class="home-page__highlights">
      <news-preview />
      <daily-statistics />
    </div>

    <home-photo-block />
  </div>
</template>

<style lang="scss">
.home-page {
  margin-top: 0;

  @include media($bp-tablet) {
    margin-top: -121px;
  }

  @include media($bp-desktop-mini) {
    margin-top: -90px;
  }

  &__highlights {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 20px 80px 20px;

    @include media($bp-tablet) {
      flex-direction: column-reverse;
      padding: 0 48px 139px 48px;
    }

    @include media($bp-desktop-mini) {
      flex-direction: row;
      padding: 0 0 140px;
    }
  }
}
</style>
